import List from '@nichoth/state/list';

var PlayerPrefs = List.extend({
    idKey: 'prefID',
    sortBy: 'prefID'
})

export default PlayerPrefs;
